import DealCodeAssignment from "./assignment"

export default DealCodeAssignment
